const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";

const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: ".product-card",
};

// Wishlist functionality
document.addEventListener("DOMContentLoaded", () => {
  CF.customerReady(function () {
    initButtons();
    initGrid();
    setNavIcon(getWishlist());
  });
});

document.addEventListener("shopify-wishlist:init", () => {
  initButtons();
  initGrid();
  setNavIcon(getWishlist());
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  // console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  setNavIcon(event.detail.wishlist);
  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
  // console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
  setNavIcon(event.detail.wishlist);
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  // console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
  setNavIcon(event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");
      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard
      );
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

function namedEventHandler(event) {
  const button = event.currentTarget;
  const productHandle = button.dataset.productHandle || false;
  setWishlist(productHandle);
  button.classList.toggle(BUTTON_ACTIVE_CLASS);
}

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);

    button.addEventListener("click", namedEventHandler);
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;

  if (grid) {
    setupGrid(grid);
  }
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];

  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  return CF.customer.get("favorites_list") || [];
};

const setWishlist = (handle) => {
  var currentArray = CF.customer.get("favorites_list") || [];

  if (!currentArray.includes(handle)) {
    // add item to customer favorites
    if (!CF.customer.id) {
      CF.customer.set("favorites_list", [...currentArray, handle]);
      CF.customer.saveAsGuest();
    } else {
      CF.customer.update({
        favorites_list: [...currentArray, handle],
      });
    }

    dispatchWishlistEvent([...currentArray, handle]);

    return [...currentArray, handle];
  } else {
    // remove item from customer favorites
    currentArray.splice(currentArray.indexOf(handle), 1);

    if (!CF.customer.id) {
      CF.customer.set("favorites_list", currentArray);
      CF.customer.saveAsGuest();
    } else {
      CF.customer.update({
        favorites_list: currentArray,
      });
    }

    dispatchWishlistEvent(currentArray);

    return currentArray;
  }
};

const dispatchWishlistEvent = (array) => {
  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

const setNavIcon = (wishList) => {
  let activeWishlistCount = document.getElementById(
    "active-wishlist-count-nav"
  );
  let wishlistIconFilled = document.getElementById("wishlist-nav-icon-filled");
  let wishlistIconEmpty = document.getElementById("wishlist-nav-icon-empty");

  if (wishList.length == 0) {
    activeWishlistCount.innerHTML = "";
    activeWishlistCount.classList.add("hidden");
    wishlistIconFilled.classList.add("hidden");
    wishlistIconEmpty.classList.remove("hidden");
  } else {
    activeWishlistCount.innerHTML = wishList.length;
    activeWishlistCount.classList.remove("hidden");
    wishlistIconFilled.classList.remove("hidden");
    wishlistIconEmpty.classList.add("hidden");
  }
};
